export const initialise = () => {
    const page: HTMLBodyElement | null = document.querySelector('.page-job-results')
    if (!page) return;
    moveHeaderToTop(page)
}

export const moveHeaderToTop = (page: HTMLElement) => {
    const header: HTMLDivElement | null = page.querySelector('.jobs-widget .attrax-list-widget__tabs')
    const hero: HTMLDivElement | null = page.querySelector('.page-job-results__hero')
    if (!header || !hero) return

    hero.after(header)
}